import React from "react";
import PropTypes from "prop-types";
import { getGroupById } from "../../store/groups";
import { useSelector } from "react-redux";
import { useI18n } from "../../i18n/LanguageContext";

const UserGroupName = ({ id }) => {
  const { t } = useI18n();
  const group = useSelector(getGroupById(id));
  return (
    <div className="flex justify-center">
      {group !== undefined ? group.teamname : t("user.notInGroup")}
    </div>
  );
};
UserGroupName.propTypes = {
  status: PropTypes.string,
};

export default UserGroupName;
